<template>
  <vx-card>
    <place-edit @done="$router.go(-1)" />
  </vx-card>
</template>

<script>
import PlaceEdit from '@/views/components/forms/PlaceEdit'

export default {
  name: 'BusinessPlaceEdit',
  components: { PlaceEdit }
}
</script>

<style scoped></style>
